var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgKnifeFork = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 16,
  viewBox: "0 0 14 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.8 0a.8.8 0 0 0-.8.8v4.368l-.8.536V.8a.8.8 0 0 0-1.6 0v4.904l-.8-.536V.8a.8.8 0 1 0-1.6 0v4.8a.8.8 0 0 0 .36.664L9.6 7.632V15.2a.8.8 0 1 0 1.6 0V7.632l2.04-1.368a.8.8 0 0 0 .36-.664V.8a.8.8 0 0 0-.8-.8Zm-8 0a4 4 0 0 0-4 4v4.8a.8.8 0 0 0 .8.8H4v5.6a.8.8 0 1 0 1.6 0V.8a.8.8 0 0 0-.8-.8ZM4 8H2.4V4A2.4 2.4 0 0 1 4 1.736V8Z",
  fill: "currentColor"
})));
export default SvgKnifeFork;